import React, { useContext } from 'react'
import { Segment, Button, Container, Divider, Header } from 'semantic-ui-react';
import { observer } from 'mobx-react-lite';
import { RootStoreContext } from '../../../../App/stores/RootStore';

interface DetailParams {
    id: string;
}

const Create: React.FC<DetailParams> = ({ id }) => {
    const rootStore = useContext(RootStoreContext)
    const { createRequestReview, submitting } = rootStore.requestReviewStore;

    return (
        <Segment clearing>
            <Header>Review Confirmation</Header>
            <Divider />
            <Container>
                Are you sure you want to start a review?
                This record will be locked to only you.
            </Container>
            <Divider />
            <Button
                loading={submitting}
                disabled={submitting}
                floated='right'
                content="Start"
                labelPosition='right'
                icon='arrow alternate circle right'
                onClick={async () => await createRequestReview(id)}
                positive
            />
        </Segment>
    )
}
export default observer(Create);